import * as vehicleTypes from 'commons-vehicle/Vehicle/actions/vehicleActionTypes.js';
import purchaseMethodsTypes from 'commons-vehicle/PurchaseMethods/actions/purchaseMethodsActionTypes.js';
import VehicleModel from 'commons-vehicle/Vehicle/models/VehicleModel.js';
import * as PurchaseMethodsService from 'commons-vehicle/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js';

export default function vehicleReducer(state = new VehicleModel(), action) {
    switch (action.type) {
        case vehicleTypes.SET_VEHICLE:
            return action.vehicle;

        case vehicleTypes.SET_VEHICLE_PURCHASE_METHODS:
            return state.set('purchaseMethods', action.purchaseMethods);

        case purchaseMethodsTypes.SELECT_PURCHASE_METHOD:
            return state.set(
                'purchaseMethods',
                PurchaseMethodsService.selectPurchaseMethod(state.purchaseMethods, action.purchaseMethod)
            );

        case purchaseMethodsTypes.SELECT_TERM:
            return state.set('purchaseMethods', PurchaseMethodsService.selectTerm(state.purchaseMethods, action.term));

        case purchaseMethodsTypes.SELECT_PAYMENT_FREQUENCY:
            return state.set(
                'purchaseMethods',
                PurchaseMethodsService.selectPaymentFrequency(state.purchaseMethods, action.paymentFrequency.value)
            );

        case purchaseMethodsTypes.SET_CASH_DOWN:
            return state.set(
                'purchaseMethods',
                PurchaseMethodsService.setCashDown(state.purchaseMethods, action.cashDown)
            );

        case purchaseMethodsTypes.SET_TRADE_IN:
            return state.set(
                'purchaseMethods',
                PurchaseMethodsService.setTradeIn(state.purchaseMethods, action.tradeIn)
            );

        case purchaseMethodsTypes.SET_LIEN:
            return state.set('purchaseMethods', PurchaseMethodsService.setLien(state.purchaseMethods, action.lien));

        case purchaseMethodsTypes.SET_EXTERIOR_COLOUR_AMOUNTS:
            return state.set(
                'purchaseMethods',
                PurchaseMethodsService.setExteriorColourAmounts(state.purchaseMethods, action.exteriorColourAmounts)
            );

        case purchaseMethodsTypes.SET_INTERIOR_COLOUR_AMOUNTS:
            return state.set(
                'purchaseMethods',
                PurchaseMethodsService.setInteriorColourAmounts(state.purchaseMethods, action.interiorColourAmounts)
            );

        case purchaseMethodsTypes.SET_OPTIONS_AMOUNTS:
            return state.set(
                'purchaseMethods',
                PurchaseMethodsService.setOptionsAmounts(state.purchaseMethods, action.optionsAmounts)
            );

        case purchaseMethodsTypes.SET_TAXES_INCLUDED:
            return state.set(
                'purchaseMethods',
                PurchaseMethodsService.setTaxesIncluded(state.purchaseMethods, action.taxesIncluded)
            );

        case purchaseMethodsTypes.SELECT_KM_PLAN:
            return state.set(
                'purchaseMethods',
                PurchaseMethodsService.selectKMPlan(state.purchaseMethods, action.kmPlan.value)
            );

        default:
            return state;
    }
}
